
export const TRANSLATIONS = {
    fr: {
        // Common
        play_now: "Jouer Maintenant",
        loading: "Chargement...",
        difficulty: "Difficulté",
        size: "Taille",
        easy: "Facile",
        medium: "Moyen",
        hard: "Difficile",
        undo: "Annuler",
        clear: "Vider",
        hint: "Indice",
        restart: "Nouveau Jeu",
        back: "Retour",
        time: "Temps",
        victory: "Victoire !",
        how_to_play: "Comment jouer",
        sun: "Soleil",
        moon: "Lune",
        row: "ligne",
        col: "colonne",
        contact_title: "Contactez-nous",
        contact_intro: "Nous sommes là pour vous aider ! Si vous avez des questions, des suggestions ou si vous souhaitez signaler un bug, n'hésitez pas à nous écrire.",
        contact_response_time: "Nous essayons de répondre à tous les emails dans les 48 heures.",

        // Cookie Consent
        cookie_message: "Nous et nos partenaires (Google) utilisons des cookies pour personnaliser les publicités, fournir des fonctionnalités de médias sociaux et analyser notre trafic.",
        cookie_accept: "Accepter",
        cookie_decline: "Continuer sans accepter",
        cookie_learn_more: "En savoir plus",

        // Privacy
        privacy_title: "Politique de Confidentialité",
        privacy_intro_title: "1. Introduction",
        privacy_intro_text: "Bienvenue sur Logic Games. Nous respectons votre vie privée et nous nous engageons à protéger vos données personnelles. Cette politique explique comment nous utilisons les cookies et autres technologies.",
        privacy_cookies_title: "2. Cookies et Publicité (Google AdSense)",
        privacy_cookies_text: "Ce site est financé par la publicité. Nous utilisons Google AdSense pour diffuser des annonces. Google et ses partenaires utilisent des cookies pour diffuser des annonces basées sur vos visites antérieures sur notre site ou sur d'autres sites Web.",
        privacy_adsense_text: "Google utilise des cookies publicitaires pour adapter les annonces à vos centres d'intérêt. Vous pouvez désactiver la publicité personnalisée dans les Paramètres des annonces Google.",
        privacy_local_text: "En plus des cookies publicitaires, nous utilisons le stockage local (LocalStorage) de votre navigateur uniquement pour sauvegarder votre progression de jeu et vos préférences (langue, thème, consentement). Ces données ne sont jamais partagées avec des tiers.",
        privacy_google_link: "Comment Google utilise les données provenant de sites utilisant ses services",
        privacy_rights_title: "3. Vos Droits (RGPD)",
        privacy_rights_text: "Conformément au Règlement Général sur la Protection des Données (RGPD), vous avez le droit d'accéder, de rectifier ou de supprimer vos données. Comme nous ne stockons aucune donnée personnelle sur nos serveurs (tout est local sur votre appareil), vous pouvez exercer ce droit simplement en effaçant les données de votre navigateur.",
        privacy_contact_title: "4. Contact",
        privacy_contact_text: "Pour toute question concernant cette politique de confidentialité, vous pouvez nous contacter à : support@puzzlepractice.online",

        // Home
        home_title: "Logic Games Training",
        home_subtitle: "Entraînez-vous aux puzzles de logique (type LinkedIn, Tests de Recrutement)",
        sudoku_desc: "Remplissez la grille pour que chaque ligne, colonne, bloc et diagonale contienne tous les chiffres unique.",
        queens_desc: "Placez des reines sans qu'elles ne se touchent ou ne partagent une ligne/colonne. Inspiré de Star Battle.",
        tango_desc: "Remplissez la grille avec des Soleils et des Lunes en respectant l'équilibre. Inspiré de Three in a Row.",

        // Tango Rules
        tango_puzzle: "Puzzle Tango",
        tango_goal_title: "Objectif du Jeu",
        tango_goal_text: "Le but est de remplir toute la grille avec des Soleils (☀️) et des Lunes (🌙) en respectant trois règles fondamentales.",
        tango_rules_title: "Règles Logiques",
        tango_rule_1: "Équilibre : Chaque ligne et chaque colonne doit contenir exactement le même nombre de Soleils et de Lunes.",
        tango_rule_2: "Séquence : Il ne peut jamais y avoir plus de deux symboles identiques côte à côte, que ce soit horizontalement ou verticalement (AAA est interdit).",
        tango_rule_3: "Le signe '=' entre deux cases signifie qu'elles doivent avoir le même symbole.",
        tango_rule_4: "Le signe 'x' entre deux cases signifie qu'elles doivent avoir des symboles différents.",
        tango_how_title: "Contrôles",
        tango_how_text: "Cliquez ou tapez sur une case vide pour y placer un Soleil. Cliquez à nouveau pour la changer en Lune. Un troisième clic efface la case.",
        tango_win_msg: "Félicitations ! L'équilibre est parfait.",
        tango_rules_note: "Astuce : Si une case devient rouge, c'est que vous avez violé une règle (ex: trois lunes de suite).",

        // Tango SEO & Extra
        about_tango_title: "À propos du Puzzle Tango (Sun & Moon)",
        tango_desc_seo: "Le Tango, souvent appelé 'Sun and Moon' ou 'Three in a Row', est un jeu de logique binaire fascinant. Contrairement au Sudoku qui utilise 9 symboles, le Tango n'en utilise que deux, ce qui change complètement la manière de raisonner. C'est un excellent exercice pour développer la pensée logique déductive.",
        tango_rules_seo_title: "Règles Détaillées et Stratégies",
        tango_rule_1_short: "Pas de trio",
        tango_rule_2_short: "Parité",
        faq_title: "Questions Fréquentes (FAQ)",
        tango_faq_1_q: "Est-ce le même jeu que sur LinkedIn ?",
        tango_faq_1_a: "Le principe est très similaire au jeu Tango proposé dans les jeux quotidiens de LinkedIn. Les règles de base (pas de trio, parité) sont identiques.",
        tango_faq_2_q: "Comment démarrer une grille difficile ?",
        tango_faq_2_a: "Cherchez d'abord les trios potentiels. Si vous voyez 'Soleil-Soleil', vous savez que les cases adjacentes sont forcément des 'Lunes'. Cherchez ensuite les motifs 'Soleil-Vide-Soleil' : la case du milieu doit être une 'Lune' pour éviter un trio.",

        // Tango Hints
        tango_hint_duo: "Placez une {target} ici. Règle : vous ne pouvez pas avoir trois {opp} d'affilée.",
        tango_hint_sandwich: "Cette case est prise en sandwich entre deux {opp}. Elle doit être un {target} pour éviter un trio.",
        tango_hint_quota: "Cette {type} a déjà atteint son quota de {count} {target}. Toutes les cases restantes doivent être des {opp}.",
        tango_hint_connector_same: "Le connecteur '=' impose que cette case soit identique à sa voisine ({target}).",
        tango_hint_connector_diff: "Le connecteur 'x' impose que cette case soit différente de sa voisine ({opp}).",
        tango_hint_duo_connector: "Il y a un connecteur '='. Si cette case était une {opp}, cela créerait un trio interdit. Elle doit donc être une {target}.",
        tango_hint_connector_diff_quota: "Les connecteurs 'x' forcent une alternance. Compte tenu des places restantes, il ne reste qu'une configuration valide.",
        tango_hint_edge_identity: "Déduction avancée : Les positions de début et fin forcent le voisin à être un {target}.",
        tango_hint_edge_match: "La paire de {opp} à l'autre extrémité de la ligne influence cette case par élimination.",
        tango_hint_uniqueness: "Cette ligne ne peut pas être identique à la ligne {index}. Changez cette case pour garantir l'unicité.",
        tango_hint_inference: "Par élimination logique, cette case ne peut être qu'un {target}.",

        // Queens Rules
        queens_puzzle: "Puzzle Queens",
        queens_goal_title: "Objectif Royal",
        queens_goal_text: "Votre mission est de placer des Couronnes (Reines) sur le plateau. Pour un plateau de taille N, vous devez placer N Reines.",
        queens_rules_title: "Les 4 Commandements",
        queens_rule_row: "Ligne : Chaque ligne horizontale ne doit contenir qu’une seule Reine.",
        queens_rule_col: "Colonne : Chaque colonne verticale ne doit contenir qu’une seule Reine.",
        queens_rule_zone: "Couleur : Chaque zone colorée ne doit contenir qu’une seule Reine.",
        queens_rule_touch: "Proximité : Deux Reines ne peuvent jamais se toucher, même par la pointe (diagonale).",
        queens_how_title: "Comment Jouer",
        queens_how_1: "Touchez une case : marque d'une Croix (X) pour dire 'pas de reine ici'.",
        queens_how_2: "Touchez encore : place une Reine (👑).",
        queens_how_3: "Touchez encore : efface la case.",
        queens_win_msg: "Le royaume est en paix ! Toutes les reines sont placées.",

        // Queens SEO
        about_queens_title: "À propos du Puzzle Queens (Star Battle)",
        queens_desc_seo: "Queens est une adaptation du célèbre jeu de logique 'Star Battle'. C'est un jeu de placement pur qui ne nécessite aucune mathématique, seulement de la déduction spatiale. Il est souvent utilisé dans les tests de QI et les évaluations de recrutement pour tester la capacité de visualisation.",
        queens_rules_seo_title: "Stratégies pour Gagner",
        tips_title: "Astuces de Pro",

        // Queens Hints
        queens_hint_proximity: "Règle de voisinage : Cette case touche une Reine existante (peut-être en diagonale). Elle doit donc être vide (X).",
        queens_hint_row: "Règle de ligne : Cette ligne contient déjà une Reine. Toutes les autres cases de la ligne doivent être des X.",
        queens_hint_col: "Règle de colonne : Cette colonne contient déjà une Reine. Marquez les autres cases avec des X.",
        queens_hint_zone: "Règle de zone : Cette zone de couleur a déjà sa Reine. Le reste de la zone est vide.",
        queens_hint_confinement_row: "Confinement : Dans cette zone colorée, toutes les cases libres sont sur une seule ligne. La Reine de la zone sera forcée sur cette ligne. Donc, le reste de cette ligne (hors zone) ne peut pas avoir de Reine.",
        queens_hint_confinement_col: "Confinement : Toutes les places possibles pour la Reine de cette zone sont dans la même colonne. Vous pouvez éliminer le reste de la colonne.",
        queens_hint_group: "Double Confinement : Ces deux zones monopolisent ces deux rangées. Aucune autre zone ne peut placer de Reine ici.",
        queens_hint_forced: "Case Forcée : C'est la seule case libre dans cette (ligne/colonne/zone). La Reine DOIT aller ici.",
        queens_hint_indirect: "Déduction indirecte : Si vous mettiez une Reine ici, cela rendrait impossible la complétion d'une autre zone voisine.",
        queens_hint_solution: "Solution unique : Selon la solution calculée, c'est ici que va la Reine.",

        // Sudoku
        sudoku_title: "Sudoku Minister",
        grid_size: "Taille de la grille",
        notes: "Mode Notes (Crayon)",
        on: "ON",
        off: "OFF",
        erase: "Gomme",
        congrats: "Félicitations !",
        sudoku_win_msg: "Grille résolue en",
        sudoku_hint_explanation: "Cette case est un {value}. C'est la seule valeur possible ici si on regarde la ligne, la colonne et le bloc.",

        // Sudoku SEO
        about_sudoku_title: "À propos du Sudoku Minister (Diagonal)",
        sudoku_desc_seo: "Le Sudoku Minister est une variante pimentée du Sudoku classique. En plus des règles traditionnelles (1-9 dans chaque ligne, colonne et carré), il ajoute une contrainte supplémentaire : les deux grandes diagonales (formant un X) doivent aussi contenir les chiffres 1 à 9 une seule fois.",
        sudoku_rules_seo_title: "Règles et Variantes",
        sudoku_strategy_title: "Stratégie Diagonale",
    },
    en: {
        // Common
        play_now: "Play Now",
        loading: "Loading...",
        difficulty: "Difficulty",
        size: "Size",
        easy: "Easy",
        medium: "Medium",
        hard: "Hard",
        undo: "Undo",
        clear: "Clear",
        hint: "Hint",
        restart: "New Game",
        back: "Back",
        time: "Time",
        victory: "Victory!",
        how_to_play: "How to Play",
        sun: "Sun",
        moon: "Moon",
        row: "row",
        col: "column",
        contact_title: "Contact Us",
        contact_intro: "We're here to help! If you have any questions, suggestions, or want to report a bug, please feel free to reach out.",
        contact_response_time: "We aim to respond to all inquiries within 48 hours.",

        // Cookie Consent
        cookie_message: "We and our partners (Google) use cookies to personalize ads, provide social media features, and analyze our traffic.",
        cookie_accept: "Accept",
        cookie_decline: "Decline",
        cookie_learn_more: "Learn more",

        // Privacy
        privacy_title: "Privacy Policy",
        privacy_intro_title: "1. Introduction",
        privacy_intro_text: "Welcome to Logic Games. We respect your privacy and represent that we are committed to protecting your personal data. This policy explains our use of cookies and other technologies.",
        privacy_cookies_title: "2. Cookies & Advertising (Google AdSense)",
        privacy_cookies_text: "This site is ad-supported. We use Google AdSense to serve advertisements. Google and its partners use cookies to serve ads based on your prior visits to our site or other websites.",
        privacy_adsense_text: "Google uses advertising cookies to tailor ads to your interests. You can opt-out of personalized advertising in Google Ad Settings.",
        privacy_local_text: "In addition to ad cookies, we use your browser's LocalStorage solely to save your game progress and preferences (language, dark mode, consent). This data effectively never leaves your device.",
        privacy_google_link: "How Google uses data when you use our partners' sites or apps",
        privacy_rights_title: "3. Your Rights (GDPR)",
        privacy_rights_text: "Under the General Data Protection Regulation (GDPR), you have the right to access, rectify, or erase your data. Since we store no personal data on our servers (everything is local), you can exercise this right simply by clearing your browser data.",
        privacy_contact_title: "4. Contact",
        privacy_contact_text: "For specific privacy questions, you can contact us at: support@puzzlepractice.online",

        // Home
        home_title: "Logic Games Training",
        home_subtitle: "Train with LinkedIn-style puzzles & Recruitment Tests",
        sudoku_desc: "Fill the grid so that every row, column, box, and diagonal contains all unique digits.",
        queens_desc: "Place queens so no two queens touch or share a row/column. Inspired by Star Battle.",
        tango_desc: "Fill the grid with Suns and Moons keeping perfect balance. Inspired by Three in a Row.",

        // Tango Rules
        tango_puzzle: "Tango Puzzle",
        tango_goal_title: "Game Goal",
        tango_goal_text: "Fill the entire grid with Suns (☀️) and Moons (🌙) while respecting three fundamental rules.",
        tango_rules_title: "Logical Rules",
        tango_rule_1: "Balance: Each row and each column must contain exactly the same number of Suns and Moons.",
        tango_rule_2: "Sequence: There can never be more than two identical symbols next to each other, horizontally or vertically (AAA is forbidden).",
        tango_rule_3: "An '=' sign between two cells means they must have the same symbol.",
        tango_rule_4: "An 'x' sign between two cells means they must have different symbols.",
        tango_how_title: "Controls",
        tango_how_text: "Click or tap an empty cell to place a Sun. Click again to change it to Moon. A third click clears the cell.",
        tango_win_msg: "Congratulations! Balance is restored.",
        tango_rules_note: "Tip: If a cell turns red, you've violated a rule (e.g., three moons in a row). Fix it to win!",

        // Tango SEO & Extra
        about_tango_title: "About Tango Puzzle (Sun & Moon)",
        tango_desc_seo: "Tango, often known as 'Sun and Moon' or 'Three in a Row', is a fascinating binary logic puzzle. Unlike Sudoku which uses 9 symbols, Tango uses only two, which changes the reasoning process entirely. It's an excellent exercise for developing deductive logical thinking.",
        tango_rules_seo_title: "Detailed Rules & Strategies",
        tango_rule_1_short: "No Trios",
        tango_rule_2_short: "Parity",
        faq_title: "Frequently Asked Questions (FAQ)",
        tango_faq_1_q: "Is this the same game as on LinkedIn?",
        tango_faq_1_a: "The concept is very similar to the Tango game featured in LinkedIn's daily games. The core rules (no trios, parity) are identical.",
        tango_faq_2_q: "How to start a hard grid?",
        tango_faq_2_a: "Look for potential trios first. If you see 'Sun-Sun', you know the adjacent cells must be 'Moons'. Then look for 'Sun-Empty-Sun' patterns: the middle cell must be a 'Moon' to prevent a trio.",

        // Tango Hints
        tango_hint_duo: "Place a {target} here. Rule: you cannot have three {opp} in a row.",
        tango_hint_sandwich: "This cell is sandwiched between two {opp}. It must be a {target} to avoid a trio.",
        tango_hint_quota: "This {type} has reached its quota of {count} {target}. All remaining cells must be {opp}.",
        tango_hint_connector_same: "The '=' connector forces this cell to be identical to its neighbor ({target}).",
        tango_hint_connector_diff: "The 'x' connector forces this cell to be different from its neighbor ({opp}).",
        tango_hint_duo_connector: "There is an '=' connector. If this cell were {opp}, it would create a forbidden trio. So it must be {target}.",
        tango_hint_connector_diff_quota: "The 'x' connectors force an alternation. Given the remaining spots, only one configuration is valid.",
        tango_hint_edge_identity: "Advanced deduction: The start and end positions force the neighbor to be a {target}.",
        tango_hint_edge_match: "The pair of {opp} at the other end influences this cell through elimination.",
        tango_hint_uniqueness: "This row cannot be identical to row {index}. Change this cell to ensure uniqueness.",
        tango_hint_inference: "By logical elimination, this cell can only be a {target}.",

        // Queens Rules
        queens_puzzle: "Queens Puzzle",
        queens_goal_title: "Royal Goal",
        queens_goal_text: "Your mission is to place Crowns (Queens) on the board. For a board of size N, you must place N Queens.",
        queens_rules_title: "The 4 Commandments",
        queens_rule_row: "Row: Each horizontal row must contain only one Queen.",
        queens_rule_col: "Column: Each vertical column must contain only one Queen.",
        queens_rule_zone: "Color: Each colored zone must contain only one Queen.",
        queens_rule_touch: "Proximity: Two Queens can never touch, not even diagonally.",
        queens_how_title: "How to Play",
        queens_how_1: "Tap a cell: marks with an X (to say 'no queen here').",
        queens_how_2: "Tap again: places a Queen (👑).",
        queens_how_3: "Tap again: clears the cell.",
        queens_win_msg: "Peace is restored to the kingdom! All queens are placed.",

        // Queens SEO
        about_queens_title: "About Queens Puzzle (Star Battle)",
        queens_desc_seo: "Queens is an adaptation of the famous logic game 'Star Battle'. It is a pure placement game requiring no math, just spatial deduction. It is often used in IQ tests and recruitment assessments to test visualization skills.",
        queens_rules_seo_title: "Strategies to Win",
        tips_title: "Pro Tips",

        // Queens Hints
        queens_hint_proximity: "Proximity Rule: This cell touches an existing Queen (possibly diagonally). It must be empty (X).",
        queens_hint_row: "Row Rule: This row already contains a Queen. All other cells in this row must be X.",
        queens_hint_col: "Column Rule: This column already contains a Queen. Mark other cells with X.",
        queens_hint_zone: "Zone Rule: This color zone already has its Queen. The rest of the zone is empty.",
        queens_hint_confinement_row: "Confinement: In this colored zone, all free cells are on a single row. The Queen for this zone MUST be on this row. Thus, the rest of the row (outside zone) cannot have a Queen.",
        queens_hint_confinement_col: "Confinement: All possible spots for this zone's Queen are in the same column. You can eliminate the rest of the column.",
        queens_hint_group: "Double Confinement: These two zones monopolize these two rows. No other zone can place a Queen here.",
        queens_hint_forced: "Forced Move: This is the only free cell in this (row/col/zone). The Queen MUST go here.",
        queens_hint_indirect: "Indirect Deduction: Placing a Queen here would make it impossible to complete a neighboring zone.",
        queens_hint_solution: "Unique Solution: According to the calculated solution, the Queen goes here.",

        // Sudoku
        sudoku_title: "Sudoku Minister",
        grid_size: "Grid Size",
        notes: "Notes Mode (Pencil)",
        on: "ON",
        off: "OFF",
        erase: "Eraser",
        congrats: "Congratulations!",
        sudoku_win_msg: "Grid solved in",
        sudoku_hint_explanation: "This cell is a {value}. It's the only possible value here considering the row, column, and box constraints.",

        // Sudoku SEO
        about_sudoku_title: "About Minister Sudoku (Diagonal)",
        sudoku_desc_seo: "Minister Sudoku is a spicy variant of classic Sudoku. In addition to the traditional rules (1-9 in every row, column, and box), it adds an extra constraint: the two main diagonals (forming an X) must also contain digits 1-9 exactly once.",
        sudoku_rules_seo_title: "Rules & Variants",
        sudoku_strategy_title: "Diagonal Strategy",
    }
};
